export const BrandStory = () => {
  return (
    <section id="story" className="py-24 md:py-32 bg-[#191646]" data-testid="brand-story-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-heading text-3xl md:text-5xl text-[#C9A85A] font-medium mb-4 tracking-tight">
          Kiplings Brand Story
        </h2>
        <p className="font-subheading text-xl md:text-2xl text-[#C9A85A]/80 italic mb-12">
          A Place for Stories, Food and Time Well Spent.
        </p>

        <div className="space-y-8">
          <p className="font-subheading text-lg md:text-xl text-white/70 leading-relaxed italic">
            In the great bistros of Europe, people don't just come to eat. They come to pause, talk, read, work, meet friends and let time slow down. Kiplings was born from this idea.
          </p>

          <p className="font-subheading text-lg md:text-xl text-white/70 leading-relaxed italic">
            Inspired by Rudyard Kipling &mdash; the writer who moved between worlds and found the richest stories at the table &mdash; Kiplings imagines a place where people gather the way thinkers and travellers once did in the great bistros of the old world, where curiosity was welcome, conversation was unhurried and a long lunch was never considered wasted time.
          </p>
        </div>

        <div className="mt-12 flex justify-center">
          <div className="w-16 h-[1px] bg-[#C9A85A]/40" />
        </div>
      </div>
    </section>
  );
};
